export const SET_IS_CLAVE = 'clave//SET_IS_CLAVE'

export const SET_SHOW_ERROR_UPLOAD_MODAL = 'clave//SET_SHOW_ERROR_UPLOAD_MODAL'

export const SET_SHOW_ERROR_SERVICE_MODAL = 'clave//SET_SHOW_ERROR_SERVICE_MODAL'

export const SET_IS_SMS_AVAILABLE = 'clave//SET_IS_SMS_AVAILABLE'

export const SET_IS_CLAVE_PIN_AVAILABLE = 'clave//SET_IS_CLAVE_PIN_AVAILABLE'

export const SET_WIDGET_URL = 'clave//SET_WIDGET_URL'

export const SET_TERMS_RESPONSE = 'clave//SET_TERMS_RESPONSE'

interface TermsResponse {
  requestId?: string
  [key: string]: any
}

interface ClaveState {
  isClave: boolean
  showClaveUploadModal: boolean
  showClaveServiceModal: boolean
  isSmsAvailable: boolean
  isClavePinAvailable: boolean
  widgetUrl: string
  termsResponse: TermsResponse | null
}

interface ClaveStore {
  clave?: ClaveState
}

interface ClaveAction {
  type: string
  payload?: boolean | string | TermsResponse | null
}

export function setIsClave(data: boolean): ClaveAction {
  return {
    type: SET_IS_CLAVE,
    payload: data,
  }
}

export function setShowErrorUploadModal(data: boolean): ClaveAction {
  return {
    type: SET_SHOW_ERROR_UPLOAD_MODAL,
    payload: data,
  }
}

export function setShowErrorServiceModal(data: boolean): ClaveAction {
  return {
    type: SET_SHOW_ERROR_SERVICE_MODAL,
    payload: data,
  }
}

export function setIsSmsAvailable(data: boolean): ClaveAction {
  return {
    type: SET_IS_SMS_AVAILABLE,
    payload: data,
  }
}

export function setIsClavePinAvailable(data: boolean): ClaveAction {
  return {
    type: SET_IS_CLAVE_PIN_AVAILABLE,
    payload: data,
  }
}

export function setWidgetUrl(data: string): ClaveAction {
  return {
    type: SET_WIDGET_URL,
    payload: data,
  }
}

export function setTermsResponse(data: TermsResponse | null): ClaveAction {
  return {
    type: SET_TERMS_RESPONSE,
    payload: data,
  }
}

export function getIsClave(store: ClaveStore): boolean | undefined {
  return store.clave?.isClave
}

export function getShowErrorUploadModal(store: ClaveStore): boolean | undefined {
  return store.clave?.showClaveUploadModal
}

export function getShowErrorServiceModal(store: ClaveStore): boolean | undefined {
  return store.clave?.showClaveServiceModal
}

export function getIsSmsAvailable(store: ClaveStore): boolean | undefined {
  return store.clave?.isSmsAvailable
}

export function getIsClavePinAvailable(store: ClaveStore): boolean | undefined {
  return store.clave?.isClavePinAvailable
}

export function getWidgetUrl(store: ClaveStore): string | undefined {
  return store.clave?.widgetUrl
}

export function getTermsResponse(store: ClaveStore): TermsResponse | null | undefined {
  return store.clave?.termsResponse
}

const initialState: ClaveState = {
  isClave: false,
  showClaveUploadModal: false,
  showClaveServiceModal: false,
  isSmsAvailable: false,
  isClavePinAvailable: false,
  widgetUrl: '',
  termsResponse: null,
}

export default function claveReducer(
  state: ClaveState = initialState,
  action: ClaveAction,
): ClaveState {
  switch (action.type) {
    case SET_IS_CLAVE:
      return {
        ...state,
        isClave: action.payload as boolean,
      }
    case SET_SHOW_ERROR_UPLOAD_MODAL:
      return {
        ...state,
        showClaveUploadModal: action.payload as boolean,
      }
    case SET_SHOW_ERROR_SERVICE_MODAL:
      return {
        ...state,
        showClaveServiceModal: action.payload as boolean,
      }
    case SET_IS_SMS_AVAILABLE:
      return {
        ...state,
        isSmsAvailable: action.payload as boolean,
      }
    case SET_IS_CLAVE_PIN_AVAILABLE:
      return {
        ...state,
        isClavePinAvailable: action.payload as boolean,
      }
    case SET_WIDGET_URL:
      return {
        ...state,
        widgetUrl: action.payload as string,
      }
    case SET_TERMS_RESPONSE:
      return {
        ...state,
        termsResponse: action.payload as TermsResponse | null,
      }

    default:
      return state
  }
}
